import { RestAPI } from '@/util/net.js';
import { Map } from 'immutable';
import { replace } from 'react-router-redux';
import { putError } from '../../../store/error.store';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';
import { saveInAction, saveFinished } from '@/store/allaround.store';
import { resolveInitialPage } from '@/store/session.store';

const REF_NAME = 'interestrate';

export const interestRateReducer = (state = new Map(), action) => {
  switch (action.type) {
    case 'INTEREST_RATE_LOADED':
      return state.set('value', action.data);
    default:
      return state;
  }
};

export const loadInterest = (dispatch) => {
  markStoreLoading(dispatch, REF_NAME);
  dispatch({ type: 'INTEREST_RATE_LOADING' });
  return RestAPI.get('/references/systemvalues/api/bigdecimal?variableName=interest_rate')
    .then(
      (data) => {
        markStoreLoaded(dispatch, REF_NAME);
        dispatch({ type: 'INTEREST_RATE_LOADED', data });
        return true;
      }
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'INTEREST_RATE_LOADING_FAILED' });
        return true;
      }
    );
};

export const goBack = (dispatch) => {
  if (!resolveInitialPage(dispatch)) {
    dispatch(replace('/deals/purchase'));
  }
};


export const save = (dispatch, value) => {
  dispatch({ type: 'UPDATE_INTEREST_RATE', value });
  saveInAction(dispatch);
  return RestAPI
    .put(`/references/systemvalues/api/bigdecimal?variableName=interest_rate&value=${value}`)
    .then(
      () => {
        saveFinished(dispatch);
        dispatch({ type: 'UPDATE_INTEREST_RATE_COMPLETED' });
        goBack(dispatch);
        loadInterest(dispatch);
        return true;
      },
    ).catch(
      (data) => {
        saveFinished(dispatch);
        putError(dispatch, data);
        dispatch({ type: 'UPDATE_INTEREST_RATE_FAILED' });
        return true;
      },
    );
};
